export const getLevelsListPath = (userGroupId: string) => {
  return `/user_groups/${userGroupId}/level_progress`;
};

export const levelsItemResourceType = "level_progress_item";
